module.exports = __webpack_public_path__ + "static/media/img-tag-moduleF1.f7f136f9.png";